import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';

// Suppress MUI capitalize warnings

const originalError = console.error;
console.error = (...args) => {
  if (args[0] && args[0].toString().includes('capitalize')) return;
  originalError.apply(console, args);
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);